import { createAction, props } from '@ngrx/store';
import { ProjectHumanResourceApiModel } from '@/core/models/api/project-human-resource.model';

// Load
export const loadProjectHumanResourcesByProject = createAction(
  '[ProjectHumanResource] Load By Project',
  props<{ projectId: number }>()
);
export const loadProjectHumanResourcesByProjectSuccess = createAction(
  '[ProjectHumanResource] Load By Project Success',
  props<{ items: ProjectHumanResourceApiModel[]; projectId: number }>()
);
export const loadProjectHumanResourcesByProjectFailure = createAction(
  '[ProjectHumanResource] Load By Project Failure',
  props<{ error: any }>()
);

// Create Range
export const createProjectHumanResources = createAction(
  '[ProjectHumanResource] Create Range',
  props<{ items: ProjectHumanResourceApiModel[] }>()
);
export const createProjectHumanResourcesSuccess = createAction(
  '[ProjectHumanResource] Create Range Success',
  props<{ items: ProjectHumanResourceApiModel[] }>()
);
export const createProjectHumanResourcesFailure = createAction(
  '[ProjectHumanResource] Create Range Failure',
  props<{ error: any }>()
);

// Update
export const updateProjectHumanResource = createAction(
  '[ProjectHumanResource] Update',
  props<{ item: ProjectHumanResourceApiModel }>()
);
export const updateProjectHumanResourceSuccess = createAction(
  '[ProjectHumanResource] Update Success',
  props<{ item: ProjectHumanResourceApiModel }>()
);
export const updateProjectHumanResourceFailure = createAction(
  '[ProjectHumanResource] Update Failure',
  props<{ error: any }>()
);

// Update Range
export const updateProjectHumanResourcesRange = createAction(
  '[ProjectHumanResource] Update Range',
  props<{ items: ProjectHumanResourceApiModel[] }>()
);
export const updateProjectHumanResourcesRangeSuccess = createAction(
  '[ProjectHumanResource] Update Range Success',
  props<{ items: ProjectHumanResourceApiModel[] }>()
);
export const updateProjectHumanResourcesRangeFailure = createAction(
  '[ProjectHumanResource] Update Range Failure',
  props<{ error: any }>()
);

// Delete
export const deleteProjectHumanResource = createAction(
  '[ProjectHumanResource] Delete',
  props<{ id: number }>()
);
export const deleteProjectHumanResourceSuccess = createAction(
  '[ProjectHumanResource] Delete Success',
  props<{ id: number }>()
);
export const deleteProjectHumanResourceFailure = createAction(
  '[ProjectHumanResource] Delete Failure',
  props<{ error: any }>()
);
